import createLoader from './createLoader';
var loadTwitter = createLoader(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? 'https://platform.twitter.com/widgets.js' : _ref$url;

  return new Promise(function (resolve) {
    var twttr = function (d, s, id) {
      var fjs = d.getElementsByTagName(s)[0];
      var t = window.twttr || {};

      if (d.getElementById(id)) {
        resolve(t);
        return t;
      }

      var js = d.createElement(s);
      js.id = id;
      js.src = url;
      fjs.parentNode.insertBefore(js, fjs);
      /* eslint-disable no-underscore-dangle */

      t._e = [];

      t.ready = function (f) {
        t._e.push(f);
      };
      /* eslint-enable no-underscore-dangle */


      return t;
    }(document, 'script', 'twitter-wjs');

    twttr.ready(resolve);
    window.twttr = twttr;
  });
}, function () {
  return typeof window.twttr !== 'undefined' && typeof window.twttr.widgets !== 'undefined' ? window.twttr : null;
});
export default loadTwitter;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/services/es/loadTwitter.js
// module id = null
// module chunks = 